import React from 'react';
import type { CreditCardHeaderProps } from '../types/credit-card.types';

const CreditCardHeader: React.FC<CreditCardHeaderProps> = ({ customerName }) => {
  return (
    <div className="text-center mb-8">
      <div className="w-16 h-16 mx-auto bg-green-100 dark:bg-green-900 rounded-full flex items-center justify-center mb-4">
        <svg 
          className="w-8 h-8 text-green-600 dark:text-green-400" 
          fill="none" 
          stroke="currentColor" 
          viewBox="0 0 24 24"
        >
          <path 
            strokeLinecap="round" 
            strokeLinejoin="round" 
            strokeWidth={2} 
            d="M5 13l4 4L19 7" 
          />
        </svg>
      </div>
      
      <h2 className="text-2xl sm:text-3xl font-bold text-primary mb-2">
        Pedido Confirmado!
      </h2>
      
      <p className="text-text-secondary dark:text-gray-300">
        Olá, <strong className="text-text-primary dark:text-gray-100">{customerName}</strong>! 
        Seu pedido foi realizado com sucesso.
      </p>
    </div>
  );
};

export default CreditCardHeader; 